import { useCallback, useState } from "react";
import { usePublicComplianceDeleteDocumentMutation } from "../../graphql/supergraph.index";
import { clientContext } from "../../utils/graphql_utils";

/**
 * A hook that provides functionality for deleting documents
 *
 * @returns Object containing function to delete documents and loading state
 */
export default function useGuestDocumentDelete() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDocument, { loading: deleteLoading }] =
    usePublicComplianceDeleteDocumentMutation({
      context: clientContext(),
    });

  /**
   * Deletes multiple documents from the system in parallel
   * Only processes documents with valid IDs
   *
   * @param documents - Documents to delete
   * @param emailToken - The email token of the guest
   */
  const deleteGuestDocuments = useCallback(
    async (documentIds: number[], emailToken: string) => {
      if (documentIds.length === 0) {
        return;
      }

      setIsDeleting(true);
      try {
        const deletions = documentIds
          .filter((data) => !!data)
          .map(async (documentId) => {
            await deleteDocument({
              variables: {
                emailToken: emailToken,
                documentId,
              },
            });
          });

        await Promise.all(deletions);
      } finally {
        setIsDeleting(false);
      }
    },
    [deleteDocument],
  );

  return {
    deleteGuestDocuments,
    loading: isDeleting || deleteLoading,
  };
}
